import PropTypes from 'prop-types';
import React from 'react';

import LabeledControl from './LabeledControl';
import Select, { SelectItem } from './Select';


function LabeledSelect({
  label,
  alignRight = false,
  bold = false,
  underline = false,
  labelSize = '30%',
  red = false,
  selectId = undefined,
  value,
  onChange = () => {},
  disabled = false,
  items = [],
  selectWidth = undefined,
}: {
  label: string,
  labelSize?: string,
  red?: boolean,
  bold?: boolean,
  underline?: boolean,
  alignRight?: boolean,
  alignCenter?: boolean,
  selectId?: string|undefined,
  value: string|number,
  onChange: (e:React.ChangeEvent<HTMLInputElement>) => void,
  disabled?: boolean,
  items?: Array<SelectItem>,
  selectWidth?: string|undefined,
  hideCaretWhenDisabled?: boolean,
}) {
  return <LabeledControl
    red={red}
    bold={bold}
    label={label}
    labelSize={labelSize}
    underline={underline}
    alignRight={alignRight}
    control={<Select selectId={selectId} value={value} onChange={onChange} disabled={disabled} items={items} selectWidth={selectWidth} />}
  />;
}

LabeledSelect.defaultProps = {
  onChange: () => {},
  value: '',
  alignRight: false,
  bold: false,
  underline: false,
  disabled: false,
  dark: false,
  labelSize: '30%',
  items: [],
  red: false,
};

LabeledSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alignRight: PropTypes.bool.isRequired,
  bold: PropTypes.bool.isRequired,
  underline: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
  labelSize: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  })).isRequired,
  red: PropTypes.bool.isRequired,
  selectWidth: PropTypes.string,
  selectId: PropTypes.string,
};


export default React.memo(LabeledSelect);
